import React from 'react'
import "./Progress.css"

const Progress = (props) => {
    const {step}=props;
  return (
    <div id='steps-progress'>
        <hr className={`step-progress-line ${step===3 && 'step-progress-line1'} ${step===4 && 'step-progress-line2'} ${step===5 && 'step-progress-line3'}`} />
        <ul className="steps">
            <li className="step step1">
                <img className='step1-icon' src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/choose-product-yellow.svg" alt="step1-icon" />
                <p className={`${step>2 ? 'selected-step-text' : 'step-text'}`}>Choose product</p>
            </li>
            <li className="step step1">
                <img className='step1-icon' src={`${step>3 ? 'https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/ad-copies-yellow.svg' : 'https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/select-ad-copies-grey.svg'}`} alt="step1-icon" />
                <p className={`${step>3 ? 'selected-step-text' : 'step-text'}`}>Select ad copies</p>
            </li>
            <li className="step step2">
                <img className='step2-icon' src={`${step>4 ? 'https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/payment-yellow.svg' : 'https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/payment-grey.svg'}`} alt="step2-icon" />
                <p className={`${step>4 ? 'selected-step-text' : 'step-text'}`}>Payment</p>
            </li>
        </ul>
    </div>
  )
}

export default Progress